import React from "react";
import "./Button.css";
import Color from "color";

export const SIZES = [ "normal", "large" ];
export const SHAPES = [ "rounded", "pill" ];
export const FONT_STYLES = [ "bold", "semibold", "shouting" ];
export const BACKGROUNDS = [ "opaque", "glass" ];

// TODO: focus, hover, click feedback

function validate(value, options) {
    if (options.indexOf(value) < 0) return options[0];
    return value;
}

function Button(props) {
    let { children, size, shape, font, background, style, color } = props;

    size = validate(size, SIZES);
    shape = validate(shape, SHAPES);
    font = validate(font, FONT_STYLES);
    background = validate(background, BACKGROUNDS);

    if (color) style = { ...style,
        "--yona-color-100": Color(color),
        "--yona-color-50": Color(color).alpha(0.5),
        "--yona-color-25": Color(color).alpha(0.25),
        "--yona-color-10": Color(color).alpha(0.1),
    }

    return (<>
       <button {...props} style={style} className={`yona-button ${size} ${shape} ${font} ${background}`}>{children}</button>
    </>);
}

export default Button;